var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4382",
    "data-name": "Group 4382",
    xmlns: "http://www.w3.org/2000/svg",
    width: 324.811,
    height: 100.005,
    viewBox: "0 0 324.811 100.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1904",
    "data-name": "Rectangle 1904",
    width: 324.811,
    height: 100.005,
    rx: 20,
    transform: "translate(0 0)",
    fill: "#f0f5f7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4381",
    "data-name": "Group 4381",
    transform: "translate(53.134 24.596)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4378",
    "data-name": "Group 4378",
    transform: "translate(70.723 0.977)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3422",
    "data-name": "Path 3422",
    d: "M1134.886,1399.32c3.594,0,5.719,2.242,5.719,6.055s-2.116,6.063-5.719,6.063h-4.073V1399.32Zm-2.561,10.757h2.461c2.746,0,4.274-1.68,4.274-4.686,0-3.031-1.52-4.711-4.274-4.711h-2.461Z",
    transform: "translate(-1130.813 -1399.32)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3423",
    "data-name": "Path 3423",
    d: "M1199.059,1422.428c0-2.788,1.629-4.518,4.048-4.518s4.04,1.73,4.04,4.518-1.629,4.518-4.04,4.518S1199.059,1425.208,1199.059,1422.428Zm6.6,0c0-2.058-1.008-3.233-2.553-3.233s-2.561,1.176-2.561,3.233,1.016,3.233,2.561,3.233S1205.66,1424.485,1205.66,1422.428Z",
    transform: "translate(-1187.19 -1414.677)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3424",
    "data-name": "Path 3424",
    d: "M1264.237,1427.513h-1.486l-1.973-6.76h-.034l-1.965,6.76h-1.486l-2.444-8.734h1.453l1.747,7.1h.034l1.973-7.1h1.411l1.982,7.1h.034l1.747-7.1h1.444Z",
    transform: "translate(-1233.277 -1415.395)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3425",
    "data-name": "Path 3425",
    d: "M1334.635,1418.061h1.377v1.394h.034a2.922,2.922,0,0,1,2.771-1.545c1.915,0,3.023,1.235,3.023,3.217v5.668h-1.461v-5.408c0-1.411-.663-2.183-2.007-2.183a2.228,2.228,0,0,0-2.276,2.452v5.14h-1.461Z",
    transform: "translate(-1299.188 -1414.677)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3426",
    "data-name": "Path 3426",
    d: "M1392.114,1399.32h1.461v12.118h-1.461Z",
    transform: "translate(-1346.671 -1399.32)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3427",
    "data-name": "Path 3427",
    d: "M1414.345,1422.428c0-2.788,1.629-4.518,4.048-4.518s4.039,1.73,4.039,4.518-1.629,4.518-4.039,4.518S1414.345,1425.208,1414.345,1422.428Zm6.6,0c0-2.058-1.008-3.233-2.553-3.233s-2.561,1.176-2.561,3.233,1.016,3.233,2.561,3.233S1420.945,1424.485,1420.945,1422.428Z",
    transform: "translate(-1365.035 -1414.677)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3428",
    "data-name": "Path 3428",
    d: "M1472.21,1424.326c0-1.495,1.15-2.435,3.166-2.553l2.5-.143v-.731c0-1.066-.706-1.7-1.915-1.7a1.833,1.833,0,0,0-2.016,1.386h-1.411c.1-1.512,1.394-2.671,3.46-2.671,2.049,0,3.342,1.109,3.342,2.847v6.038h-1.386v-1.5h-.034a3.185,3.185,0,0,1-2.8,1.654A2.624,2.624,0,0,1,1472.21,1424.326Zm5.669-.848v-.714l-2.335.143c-1.176.076-1.848.6-1.848,1.419s.7,1.377,1.747,1.377A2.3,2.3,0,0,0,1477.879,1423.478Z",
    transform: "translate(-1412.837 -1414.677)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3429",
    "data-name": "Path 3429",
    d: "M1526.357,1407.071c0-2.738,1.5-4.518,3.7-4.518a3.068,3.068,0,0,1,2.779,1.57h.034v-4.8h1.461v12.118h-1.394v-1.478h-.025a3.125,3.125,0,0,1-2.822,1.629C1527.869,1411.589,1526.357,1409.809,1526.357,1407.071Zm1.495,0c0,1.982.974,3.233,2.519,3.233,1.5,0,2.511-1.276,2.511-3.233s-1.008-3.233-2.511-3.233C1528.826,1403.838,1527.852,1405.1,1527.852,1407.071Z",
    transform: "translate(-1457.567 -1399.32)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3430",
    "data-name": "Path 3430",
    d: "M1611.281,1422.428c0-2.788,1.629-4.518,4.048-4.518s4.039,1.73,4.039,4.518-1.629,4.518-4.039,4.518S1611.281,1425.208,1611.281,1422.428Zm6.6,0c0-2.058-1.008-3.233-2.553-3.233s-2.562,1.176-2.562,3.233,1.016,3.233,2.562,3.233S1617.882,1424.485,1617.882,1422.428Z",
    transform: "translate(-1527.722 -1414.677)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3431",
    "data-name": "Path 3431",
    d: "M1671.175,1418.061h1.377v1.394h.034a2.922,2.922,0,0,1,2.771-1.545c1.915,0,3.023,1.235,3.023,3.217v5.668h-1.461v-5.408c0-1.411-.663-2.183-2.007-2.183a2.228,2.228,0,0,0-2.276,2.452v5.14h-1.461Z",
    transform: "translate(-1577.2 -1414.677)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3432",
    "data-name": "Path 3432",
    d: "M1751.426,1406.659v2.108h1.7v1.2h-1.7v5.19c0,.8.336,1.159,1.083,1.159a5.667,5.667,0,0,0,.6-.042v1.226a5.206,5.206,0,0,1-.924.067c-1.6,0-2.225-.655-2.225-2.334v-5.265h-1.3v-1.2h1.3v-2.108Z",
    transform: "translate(-1641.211 -1405.383)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3433",
    "data-name": "Path 3433",
    d: "M1788.614,1399.32h1.461v4.778h.034a2.891,2.891,0,0,1,2.771-1.545,2.948,2.948,0,0,1,3.074,3.242v5.643h-1.461v-5.375a1.937,1.937,0,0,0-2.066-2.217,2.269,2.269,0,0,0-2.351,2.5v5.089h-1.461Z",
    transform: "translate(-1674.215 -1399.32)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3434",
    "data-name": "Path 3434",
    d: "M1851.628,1424.292a3.459,3.459,0,0,1-3.636,2.654c-2.5,0-4.022-1.739-4.022-4.484,0-2.713,1.545-4.552,3.955-4.552,2.36,0,3.813,1.713,3.813,4.359v.554h-6.265v.084a2.5,2.5,0,0,0,2.553,2.771,2.108,2.108,0,0,0,2.167-1.386Zm-6.147-2.612h4.745a2.336,2.336,0,0,0-2.326-2.5A2.454,2.454,0,0,0,1845.481,1421.681Z",
    transform: "translate(-1719.943 -1414.677)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4379",
    "data-name": "Group 4379",
    transform: "translate(70.044 22.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3435",
    "data-name": "Path 3435",
    d: "M1135.112,1524.827h3.78l8.185,22.541h-3.671l-2.062-6.092h-8.685l-2.078,6.092h-3.671Zm-1.515,13.637h6.795l-3.358-9.9h-.062Z",
    transform: "translate(-1126.911 -1524.452)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3436",
    "data-name": "Path 3436",
    d: "M1264.018,1558.463h3.374v2.828h.078a5.535,5.535,0,0,1,5.139-3.14c4.187,0,6.873,3.28,6.873,8.529v.015c0,5.233-2.7,8.529-6.826,8.529a5.645,5.645,0,0,1-5.186-3.093h-.078v8.232h-3.374Zm12.028,8.232v-.015c0-3.5-1.672-5.639-4.312-5.639-2.562,0-4.358,2.218-4.358,5.639v.015c0,3.405,1.812,5.624,4.358,5.624C1274.39,1572.318,1276.046,1570.162,1276.046,1566.694Z",
    transform: "translate(-1240.173 -1551.98)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3437",
    "data-name": "Path 3437",
    d: "M1377.142,1558.463h3.374v2.828h.078a5.535,5.535,0,0,1,5.139-3.14c4.187,0,6.873,3.28,6.873,8.529v.015c0,5.233-2.7,8.529-6.826,8.529a5.645,5.645,0,0,1-5.186-3.093h-.078v8.232h-3.374Zm12.028,8.232v-.015c0-3.5-1.672-5.639-4.312-5.639-2.562,0-4.358,2.218-4.358,5.639v.015c0,3.405,1.812,5.624,4.358,5.624C1387.514,1572.318,1389.17,1570.162,1389.17,1566.694Z",
    transform: "translate(-1333.624 -1551.98)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3438",
    "data-name": "Path 3438",
    d: "M1533.253,1539.589l-.016-.234h3.405l.031.2c.312,2.078,2.39,3.374,5.4,3.374s4.92-1.359,4.92-3.468v-.016c0-1.812-1.234-2.8-4.218-3.452l-2.453-.515c-4.421-.937-6.561-2.968-6.561-6.311v-.016c.016-3.843,3.405-6.483,8.17-6.483,4.7,0,7.92,2.562,8.154,6.342l.016.266H1546.7l-.016-.219c-.312-2.093-2.125-3.358-4.8-3.358-2.8.016-4.577,1.343-4.577,3.312v.016c0,1.687,1.281,2.718,4.093,3.327l2.468.516c4.655.984,6.654,2.874,6.654,6.358v.016c0,4.108-3.249,6.717-8.591,6.717C1536.877,1545.963,1533.534,1543.557,1533.253,1539.589Z",
    transform: "translate(-1462.572 -1522.672)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3439",
    "data-name": "Path 3439",
    d: "M1651.864,1551.722V1542.3h-2.359v-2.687h2.359v-4.28h3.452v4.28h3.077v2.687h-3.077v9.216c0,1.671.75,2.171,2.171,2.171a7.053,7.053,0,0,0,.906-.062v2.609a11.309,11.309,0,0,1-1.718.14C1653.427,1556.377,1651.864,1555,1651.864,1551.722Z",
    transform: "translate(-1558.62 -1533.134)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3440",
    "data-name": "Path 3440",
    d: "M1719.334,1566.679v-.031c0-5.248,3.109-8.5,7.779-8.5,4.686,0,7.81,3.234,7.81,8.5v.031c0,5.3-3.093,8.544-7.795,8.544C1722.411,1575.223,1719.334,1571.959,1719.334,1566.679Zm12.137,0v-.031c0-3.593-1.718-5.67-4.358-5.67-2.593,0-4.327,2.078-4.327,5.67v.031c0,3.639,1.718,5.717,4.358,5.717S1731.471,1570.3,1731.471,1566.679Z",
    transform: "translate(-1616.305 -1551.98)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3441",
    "data-name": "Path 3441",
    d: "M1833.176,1558.463h3.374v2.812h.078a3.867,3.867,0,0,1,3.78-3.124,6.522,6.522,0,0,1,1.172.125v3.14a4.838,4.838,0,0,0-1.515-.187c-2.171,0-3.515,1.421-3.515,3.874v9.794h-3.374Z",
    transform: "translate(-1710.348 -1551.98)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3442",
    "data-name": "Path 3442",
    d: "M1894.473,1566.742v-.016c0-5.139,2.968-8.576,7.576-8.576s7.435,3.312,7.435,8.248v1.14h-11.637c.062,3.109,1.765,4.921,4.452,4.921a3.726,3.726,0,0,0,3.749-2.265l.047-.125h3.2l-.031.172c-.531,2.609-3.062,4.983-7.045,4.983C1897.394,1575.223,1894.473,1571.928,1894.473,1566.742Zm3.421-1.593h8.248c-.281-2.843-1.875-4.233-4.077-4.233C1899.877,1560.915,1898.191,1562.4,1897.894,1565.148Z",
    transform: "translate(-1760.985 -1551.98)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4380",
    "data-name": "Group 4380"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3443",
    "data-name": "Path 3443",
    d: "M764.136,1412.039a12.965,12.965,0,0,0-4.291,4.406,10.341,10.341,0,0,0-1.135,4.791,10.008,10.008,0,0,0,.673,3.732,12.313,12.313,0,0,0,1.9,3.213,13.015,13.015,0,0,0,4.117,3.021,27.534,27.534,0,0,1-3.463,6.677,20.89,20.89,0,0,1-4.252,4.829,6.153,6.153,0,0,1-3.636,1.424,11.325,11.325,0,0,1-3.732-.885l-.731-.269-1.193-.5a9.688,9.688,0,0,0-2.809-.385,10.764,10.764,0,0,0-3.54.693l-.923.346-1.154.462a7.585,7.585,0,0,1-2.771.539q-2.925,0-6.272-4.1a30.122,30.122,0,0,1-5.06-8.812,27.7,27.7,0,0,1-1.713-9.524,15.311,15.311,0,0,1,3.521-10.313,11.928,11.928,0,0,1,9.562-4.117,10.528,10.528,0,0,1,4.117.808l.885.346.923.385a5.6,5.6,0,0,0,1.962.5,5.85,5.85,0,0,0,2.155-.423l1.232-.462.885-.346a13.5,13.5,0,0,1,4.772-.808A12.08,12.08,0,0,1,764.136,1412.039Zm-9.774-18.338q.077.847.077,1.308a10.265,10.265,0,0,1-1.385,4.925,10.461,10.461,0,0,1-3.617,3.944,9.061,9.061,0,0,1-4.925,1.4,12.2,12.2,0,0,1-.115-1.347,9.074,9.074,0,0,1,1.212-4.291,11.778,11.778,0,0,1,3.29-3.829,10.394,10.394,0,0,1,4.695-2C753.746,1393.792,754,1393.754,754.362,1393.7Z",
    transform: "translate(-724.155 -1393.702)",
    fill: "#333"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app-store.2f3579d9328ae63313e0157d67e625b1.svg";
export { ForwardRef as ReactComponent };